import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import ReadingChallengeNewsfeedItem from "./reading_challenge_newsfeed_item";

const CHALLENGE_TYPES = {
  READING_CHALLENGE: "y",
};

export default GrComponentFactory.createClass({
  displayName: "ChallengeNewsfeedItem",
  propTypes: {
    resource: React.PropTypes.shape({
      challenge: React.PropTypes.shape({
        type: React.PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    urcDeprecateViewChallengeLink: React.PropTypes.bool,
  },

  render() {
    if (this.props.resource.challenge.type === CHALLENGE_TYPES.READING_CHALLENGE) {
      return <ReadingChallengeNewsfeedItem {...this.props} />;
    } else {
      return null;
    }
  },
});
